// extracted by mini-css-extract-plugin
export default {"messages":"ActionText_messages__YollM","button":"ActionText_button__USfQ0"};